import React, { useEffect, useState } from 'react';
// import Statistics from './TeamsStatistics';
import Table from './TeamsTable';
import { useQuery } from '@apollo/client';
import { getAssociationQuery, ongoingPeriodsInAssociationQuery } from '../../../queries/queries';
import { useNavigationContext } from '../../../context/NavigationContext';
import { PageHeader } from '../../../common';

function DashboardAssociationTeams(props) {

  const { association: associationId } = props.match.params;
  const { data: associationData } = useQuery(getAssociationQuery, {
    variables: { associationId: associationId }
  });

  const [period, setPeriod] = useState();
  const { data: agreementPeriods } = useQuery(ongoingPeriodsInAssociationQuery, {
    variables: {
      associationId
    }
  });

  const { setNavigationActivated } = useNavigationContext();
  useEffect(() => {
    setNavigationActivated(true);
  }, []);

  useEffect(() => {
    agreementPeriods && setPeriod(agreementPeriods.periods.currentPeriod)
  }, [agreementPeriods]);

  return (
    <div id="dashboard" className="teams">
      <PageHeader>
        <h1>Lag</h1>
        <p>Här lägger du till och hanterar lagen som ska sälja häftet via egen webbshop.</p>
      </PageHeader>
      <div className="container flex justify-center">
        <div className="dashboard-table-container md">
          <Table associationId={associationId} associationData={associationData} period={period} />
        </div>
      </div>
      {/* <Statistics associationId={associationId} period={period} setPeriod={setPeriod} agreementPeriods={agreementPeriods} /> */}
    </div>
  );
}

export default DashboardAssociationTeams;
